import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes.json';
import HomePage from './pages/HomePage';
import MissionVisionPage from './pages/MissionVisionPage';
import ComingSoonPage from './pages/ComingSoonPage';
import OurCampusPage from './pages/OurCampusPage';
import OurAcademicsPage from './pages/OurAcademicsPage';
import PrincipalLetterPage from './pages/PrincipalLetterPage';

// Routing is data-driven from the single in-src manifest `src/routes.json`,
// the same file the prerender script reads — so routing AND static prerendering
// stay in sync from one source.
//
// To ADD a page: create `src/pages/<Name>.jsx`, import it here, add it to
// `registry` below, and add an entry to `src/routes.json` — routing +
// prerendering pick it up automatically.
// To REMOVE: delete its routes.json entry, registry line, import, and the
// component file.
const registry = {
  HomePage,
  MissionVisionPage,
  OurCampusPage,
  OurAcademicsPage,
  ComingSoonPage,
  PrincipalLetterPage,
};

function App() {
  return (
    <Router>
      <Routes>
        {routes.map(({ path, component }) => {
          const C = registry[component];
          return C ? <Route key={path} path={path} element={<C />} /> : null;
        })}
      </Routes>
    </Router>
  );
}

export default App;
